import { render, staticRenderFns } from "./newSingleOffers.vue?vue&type=template&id=47345252&"
import script from "./newSingleOffers.vue?vue&type=script&lang=js&"
export * from "./newSingleOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports